const getDeepLink = (subdomain, page) => {
  const { REACT_APP_THINKIFIC_ENDPOINT } = process.env;
  return `https://${subdomain}.${REACT_APP_THINKIFIC_ENDPOINT}/${page}`;
};

export default getDeepLink;
